import React from 'react';
import { getIn, connect } from 'formik';
import FieldAlert from './FieldAlert';

const FieldError = ({ formik, name }) => {

  const error = getIn(formik.errors, name);

  return !!error
    ? <FieldAlert message={error} />
    : null;
}

export default connect(FieldError);



// WEBPACK FOOTER //
// ./src/components/form/FieldError.js